export default function printTable({ title, subtitle, columns, rows, styles = {} }) {
  const colWidths = styles.colWidths || columns.map(() => `${100 / columns.length}%`);

  const headerCells = columns.map((col, i) =>
    `<th style="width:${colWidths[i]};padding:8px 10px;text-align:left;
      background:#f8fafc;color:#475569;font-size:11px;font-weight:700;
      text-transform:uppercase;letter-spacing:0.05em;border-bottom:2px solid #e2e8f0;
      white-space:nowrap;">${col}</th>`
  ).join('');

  const bodyRows = rows.map((row, ri) =>
    `<tr style="background:${ri % 2 === 0 ? '#ffffff' : '#f8fafc'};">
      ${row.map((cell, ci) =>
        `<td style="width:${colWidths[ci]};padding:7px 10px;font-size:12px;
          color:#1e293b;border-bottom:1px solid #f1f5f9;
          ${cell?.style || ''}">${cell?.value ?? cell ?? '—'}</td>`
      ).join('')}
    </tr>`
  ).join('');

  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/>
    <title>${title}</title>
    <style>
      * { box-sizing: border-box; margin: 0; padding: 0; }
      body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
             padding: 24px; color: #1e293b; }
      .header { margin-bottom: 20px; border-bottom: 2px solid #e2e8f0; padding-bottom: 14px; }
      .title { font-size: 20px; font-weight: 700; color: #0f172a; margin-bottom: 4px; }
      .subtitle { font-size: 12px; color: #64748b; }
      .meta { font-size: 11px; color: #94a3b8; margin-top: 4px; }
      table { width: 100%; border-collapse: collapse; }
      @media print {
        body { padding: 12px; }
        @page { margin: 1cm; size: landscape; }
      }
    </style>
  </head><body>
    <div class="header">
      <div class="title">${title}</div>
      ${subtitle ? `<div class="subtitle">${subtitle}</div>` : ''}
      <div class="meta">Printed on ${new Date().toLocaleString()}</div>
    </div>
    <table>
      <thead><tr>${headerCells}</tr></thead>
      <tbody>${bodyRows}</tbody>
    </table>
  </body></html>`;

  const win = window.open('', '_blank', 'width=900,height=650');
  if (!win) { alert('Please allow popups to print.'); return; }
  win.document.write(html);
  win.document.close();
  win.focus();
  // slight delay so fonts/layout settle before print dialog
  setTimeout(() => { win.print(); win.close(); }, 400);
}